import { render, staticRenderFns } from "./TextDialog.vue?vue&type=template&id=28cb4307"
import script from "./TextDialog.vue?vue&type=script&lang=js"
export * from "./TextDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports